// Japan
export const locale = {
	lang: 'jp',
	data: {
		LISTING_HUB: {
			TITLE: 'Listing Hub',
			GRID: {
				CREATE: 'Create Listing',
				NEW_PRODUCT: 'New Product',
				SEARCH_PLACEHOLDER: 'Search by SKU or title...',
				FILTERS: {
					ALL: 'All',
					NOT_LISTED: 'Not listed',
					AMAZON_ONLY: 'Amazon only',
					PARTIALLY_LISTED: 'Partially listed',
					FULLY_LISTED: 'Fully listed',
					NEEDS_CONTENT: 'Needs content'
				},
				INCLUDE_INACTIVE: 'Include inactive',
				COLUMNS: {
					IMAGE: 'Image',
					SKU: 'SKU',
					TITLE: 'Title',
					MARKETPLACES: 'Marketplaces',
					QUALITY: 'Quality',
					HUB_STATUS: 'Hub status',
					STATUS: 'Status',
					UPDATED: 'Updated',
					ACTIONS: 'Actions'
				},
				LISTED_TOOLTIP: '{{store}} — listed, {{listingId}}',
				NOT_LISTED_TOOLTIP: 'Not listed on {{store}}',
				NOT_LISTED_DRAFT_TOOLTIP: 'Not listed on {{store}} — hub draft in progress',
				CLICKUP_LINKED_TOOLTIP: 'Linked to ClickUp: {{taskId}}',
				CREATE_LISTING: 'Create listing',
				EDIT_LISTING: 'Edit listing',
				EXPAND: 'List on more',
				EXPAND_TOOLTIP: 'List on {{stores}}',
				QUALITY: {
					TOOLTIP_TITLE: 'Listing quality',
					POINTS_HINT: '+{{points}} pts',
					GRADES: {
						POOR: 'Poor',
						FAIR: 'Fair',
						GOOD: 'Good',
						EXCELLENT: 'Excellent'
					}
				},
				DELETE_TITLE: 'Delete Listing?',
				DELETE_MESSAGE: 'Do you really want to delete this master listing? Marketplace variants based on it will be removed as well.'
			},
			NEW_PRODUCT: {
				MODAL_TITLE: 'New Product',
				SKU: 'SKU',
				SKU_PLACEHOLDER: 'Enter a unique SKU...',
				TITLE: 'Title',
				TITLE_PLACEHOLDER: 'Enter the product title...',
				UPC: 'UPC',
				UPC_PLACEHOLDER: 'Optional UPC / barcode...',
				CREATE: 'Create product',
				CREATED: 'Product {{sku}} created',
				DUPLICATE_SKU: 'SKU {{sku}} already exists'
			},
			WIZARD: {
				CREATE_TITLE: 'Create Listing',
				EDIT_TITLE: 'Edit Listing',
				STEPS: {
					SOURCE: 'Source & Product',
					MASTER: 'Master Content',
					VARIANTS: 'Marketplace Variants',
					MARKETPLACES: 'Marketplace & Category',
					CONTENT: 'Listing Content',
					REVIEW: 'Review & Publish'
				},
				BACK: 'Back',
				NEXT: 'Next',
				VIEW_STATUS: 'View status',
				SAVE_DRAFT: 'Save Draft',
				SAVED: 'Draft saved',
				INVALID: 'Please fix the highlighted fields before saving',
				COMING_SOON: 'Coming soon — this step will be available in an upcoming release'
			},
			SOURCE: {
				MANUAL_TITLE: 'Manual entry',
				MANUAL_DESC: 'Start from a blank listing and enter all content yourself',
				AMAZON_TITLE: 'Seed from Amazon',
				AMAZON_DESC: 'Pre-fill the listing from the product\'s Amazon catalog data',
				CLICKUP_TITLE: 'Import from ClickUp',
				CLICKUP_DESC: 'Pull listing content from a ClickUp task',
				PRODUCT: 'Product',
				PRODUCT_PLACEHOLDER: 'Select a product...',
				SUB_INFO: 'This is a Sub product — the listing will be attached to its Main product.',
				STORE: 'Amazon store',
				SEED: 'Fetch from Amazon',
				SELECT_PRODUCT_FIRST: 'Please select a product first',
				SELECT_STORE_FIRST: 'Please select an Amazon store first',
				CLICKUP_DISABLED: 'Configure ClickUp in Settings → Integrations',
				CLICKUP_IMPORT: 'Import from ClickUp'
			},
			MASTER: {
				TITLE: 'Title',
				DESCRIPTION: 'Description',
				BULLET_POINT: 'Bullet point',
				KEYWORDS: 'Search keywords',
				KEYWORDS_PLACEHOLDER: 'Type a keyword and press Enter...',
				BRAND: 'Brand',
				MANUFACTURER: 'Manufacturer',
				DIMENSIONS: 'Dimensions & weight',
				HEIGHT: 'Height',
				WIDTH: 'Width',
				LENGTH: 'Length',
				WEIGHT: 'Weight',
				ATTRIBUTES: 'Attributes',
				ATTRIBUTE_KEY: 'Name',
				ATTRIBUTE_VALUE: 'Value',
				ADD_ATTRIBUTE: 'Add attribute',
				IMAGES: 'Images',
				AI_COMING_SOON: 'AI suggestions coming soon',
				SET_MAIN_IMAGE: 'Set as main image',
				MAIN_IMAGE: 'Main',
				DROP_IMAGES: 'Drop or click to upload images',
				IMAGES_QUEUED: 'Images will be uploaded when the draft is saved'
			},
			VARIANTS: {
				COPY_FROM_MAIN: 'Copy this field from the main listing',
				COPY_ALL_FROM_MAIN: 'Copy all from main',
				COPY_ALL_CONFIRM: 'Copy the main listing\'s title, description, bullet points and search keywords into this marketplace? They become this marketplace\'s own editable copy and stop following main. Nothing is saved until you click Save.',
				REMOVE: 'Remove {{store}} from this listing',
				REMOVE_CONFIRM: 'Remove {{store}} from this listing? Its category, overrides and attribute answers are deleted. The listing itself and the other marketplaces are untouched.',
				REMOVE_ANYWAY: 'Remove it here anyway?',
				REMOVED: '{{store}} removed from this listing',
				REMOVE_FAILED: 'Could not remove {{store}}',
				STORES_NOT_LOADED: 'Your marketplace stores could not be loaded.',
				RELOAD_STORES: 'Try again',
				SHOW_FROM_CONTENT: 'Show {{count}} fields filled from the listing content',
				HIDE_FROM_CONTENT: 'Hide fields filled from the listing content',
				SAVE_MASTER_FIRST: 'Save the master content draft first — marketplace variants attach to a saved listing.',
				STORE: 'Marketplace store',
				STORE_PLACEHOLDER: 'Select a marketplace store...',
				ADD_MARKETPLACE: 'Add marketplace',
				SELECT_ALL: 'Select all',
				SELECT_THEN_NEXT: 'Select the marketplaces to list on, then click Next.',
				NO_STORES: 'No listable marketplace stores are connected to this organization.',
				ALL_STORES_ADDED: 'Every eligible store already has a variant.',
				NO_VARIANTS: 'No marketplace variants yet — pick a store and click "Add marketplace".',
				VARIANT_CREATED: 'Marketplace variant added',
				SAVES_INDEPENDENTLY: 'Changes in each marketplace are saved independently.',
				OVERRIDDEN: 'Overridden',
				OVERRIDE: 'Override this field for this marketplace',
				REVERT: 'Revert to master value',
				FROM_MASTER: 'Inherited from master',
				BULLET_POINTS: 'Bullet points',
				SAVE: 'Save marketplace changes',
				SAVED: 'Marketplace changes saved',
				PRODUCT_TYPE: 'Product type / category',
				PRODUCT_TYPE_PLACEHOLDER: 'Search a category…',
				REFRESH_SCHEMA: 'Refresh schema',
				SCHEMA_REFRESHED: 'Marketplace schema refreshed',
				NO_SCHEMA: 'No attribute schema is available for this marketplace yet — try refreshing.',
				BLOCKED_MISSING: 'Amazon still needs required attributes on {{detail}} - fill them in before continuing',
				BLOCKED_UNREVIEWED: 'Open {{detail}} and fill in its required marketplace attributes before continuing',
				FROM_LISTING_CONTENT: 'Sent from the listing content unless you enter something here',
				SHOW_OPTIONAL: 'Show optional fields',
				HIDE_OPTIONAL: 'Hide optional fields',
				PRICE: 'Price on this marketplace',
				PRICE_PLACEHOLDER: 'e.g. 15.99',
				PRICE_BOUNDS: 'Price settings for this SKU on this store — min {{min}} · max {{max}}',
				PRICE_NO_BOUNDS: 'This SKU has no min/max price for this store yet.',
				PRICE_REQUIRED_TO_PUBLISH: 'A price is needed to publish — a listing published without one goes live unbuyable.',
				PRICE_BELOW_MIN: 'Below the minimum price on file ({{bound}}) — the repricer will not sell under it.',
				PRICE_ABOVE_MAX: 'Above the maximum price on file ({{bound}}) — the repricer will pull it back down.',
				PRICE_SET_MIN: 'Set the minimum to {{price}}',
				PRICE_SET_MAX: 'Set the maximum to {{price}}',
				PRICE_BOUNDS_SAVED: 'Price settings updated for this store',
				ATTRIBUTES: 'Marketplace attributes'
			},
			REVIEW: {
				NO_VARIANTS: 'Nothing to review yet — add marketplace variants in the previous step.',
				FIELDS_OVERRIDDEN: '{{count}} fields overridden',
				MISSING_REQUIRED: '{{count}} required fields missing',
				READY: 'All required fields complete',
				NOT_CHECKED: 'Open the variant tab to validate required fields',
				CHECKLIST: 'Readiness checklist',
				CHECK_TITLE: 'Title present',
				CHECK_IMAGES: 'At least one image',
				CHECK_UPC: 'Product UPC / GTIN present',
				CHECK_PRICE: 'Price set',
				CHECK_ATTRIBUTES: 'Required marketplace attributes complete',
				CHECK_STORE: 'Store connected',
				SELECT_FOR_PUBLISH: 'Publish this marketplace',
				PUBLISH: 'Publish',
				PUBLISH_SELECTED: 'Publish ({{count}})',
				PUBLISHING: 'Publishing...',
				PUBLISH_SUCCESS: '{{store}}: publish submitted',
				PUBLISH_FAILED: '{{store}}: publish failed',
				PUBLISH_REJECTED: 'the marketplace rejected the request',
				ACK_TITLE: 'Listing already exists on Amazon',
				ACK_MESSAGE: 'This SKU already exists on Amazon. Publishing from the Listing Hub fully replaces the live listing content with this variant\'s content.',
				ACK_CONFIRM: 'Publish anyway'
			},
			STATUS: {
				FIX_ATTRIBUTES: 'Fix the listing',
				TITLE: 'Publish status',
				BACK_TO_HUB: 'Back to Listing Hub',
				EDIT_LISTING: 'Edit listing',
				NO_VARIANTS: 'This listing has no marketplace variants yet.',
				NO_SUBMISSIONS: 'This marketplace has not been published yet.',
				POLLING: 'Auto-refreshing every 8 seconds while publishing is in progress',
				STAGES: {
					PENDING: 'Pending',
					SUBMITTED: 'Submitted',
					PROCESSING: 'Processing',
					PUBLISHED: 'Published',
					ERROR: 'Error'
				},
				ISSUES: 'Marketplace issues',
				RETRY: 'Retry',
				RETRY_STARTED: '{{store}}: publish retry submitted',
				VIEW_LISTING: 'View listing',
				PREVIOUS_ATTEMPTS: 'Previous attempts',
				PUBLISHED_TOAST: '{{store}}: listing published',
				ERROR_TOAST: '{{store}}: publish failed'
			},
			AI_FILL: {
				APPLIED: 'Applied',
				REDO_ONE: 'Propose this one again',
				RETRY_REMAINING: 'Propose the rest again',
				BUTTON: 'Fill with AI',
				TITLE: 'AI-proposed attributes',
				WORKING: 'Reading the listing and proposing values...',
				FAILED: 'Could not propose attribute values',
				NOTHING: 'The AI could not determine any of the remaining attributes from what the listing says. Add more product detail and try again.',
				REVIEW_NOTE: 'Nothing is filled in until you accept it. Check the safety and compliance answers against the real product before applying them.',
				SELECT_ALL: 'Select all',
				COUNT: '{{accepted}} of {{total}} selected',
				USE: 'Use',
				APPLY: 'Apply {{count}}',
				RETRY: 'Try again',
				TRUNCATED: 'This is the first batch of {{eligible}} eligible attributes. Apply these, then run it again for the rest.',
				SKIPPED: '{{count}} answers the marketplace would not accept',
				INSTRUCTION_PLACEHOLDER: 'Anything the AI should know, e.g. \'it is 100% cotton, ages 3+\'',
				INCLUDE_OPTIONAL: 'Include optional'
			},
			AI: {
				IMPROVE: 'Improve with AI',
				IMPROVE_ALL: 'Improve entire listing with AI',
				CREATE_ALL: 'Create listing with AI',
				CREATE_MODAL_TITLE: 'Create this listing with AI',
				CREATE_MODAL_HINT: 'Paste whatever you already have about the product - a supplier blurb, a spec sheet, an email - and say which direction to take it. The title, description, bullet points and search terms are written from that, and you choose what to keep.',
				CREATE_GENERATE: 'Generate listing',
				IMPROVE_MODAL_TITLE: 'Improve this listing with AI',
				IMPROVE_MODAL_HINT: 'The AI reads the listing as it stands. Anything you add here - more text about the product, a direction to take it, a picture, listings to learn from - is used on top of it.',
				IMPROVE_GENERATE: 'Improve listing',
				IMAGE_LABEL: 'A picture of the product (optional)',
				IMAGE_HINT: 'The AI looks at it to see what the product is. PNG, JPEG, GIF or WebP, up to 4 MB. It is only sent with this request - the listing images are separate.',
				IMAGE_TYPE_ERROR: 'That file is not an image the AI can read - use PNG, JPEG, GIF or WebP.',
				IMAGE_SIZE_ERROR: 'That image is over 4 MB - a smaller one works just as well.',
				REFERENCES_LABEL: 'Similar listings for ideas (optional)',
				REFERENCES_PLACEHOLDER: 'ASINs or Amazon links, separated by spaces or commas',
				REFERENCES_HINT: 'Their titles and bullet points are read from Amazon and used for style and coverage only - the AI is told not to copy their wording or claims.',
				INSTRUCTION_LABEL: 'What do you want from it?',
				ALL_TITLE: 'AI suggestions — entire listing',
				APPLY_ALL: 'Apply all',
				CHECK_TRADEMARKS: 'Check for trademarks',
				SOURCE_LABEL: 'Generate from your own text (optional)',
				SOURCE_PLACEHOLDER: 'Paste product info, a spec sheet, or a Google Doc’s text here…',
				INSTRUCTION_PLACEHOLDER: 'Tell the AI what you want, e.g. \'focus on durability, casual tone\'',
				NO_KEY_TOOLTIP: 'Configure an AI key in Settings → Integrations to enable suggestions',
				NO_KEY_MESSAGE: 'Configure an AI key in Settings → Integrations',
				PANEL_TITLE: 'AI suggestion',
				CURRENT: 'Current',
				SUGGESTION: 'Suggestion',
				LOADING: 'Generating suggestion...',
				FAILED: 'Could not get a suggestion',
				RETRY: 'Try again',
				USE: 'Use suggestion',
				REWRITE: 'Rewrite',
				REWRITE_PLACEHOLDER: 'Optional instruction, e.g. "make it shorter"...',
				REWRITE_SUBMIT: 'Get new suggestion',
				ADD: 'Add to existing',
        ADD_TITLE: 'Keep the keywords you have and add the new ones',
        PER_BULLET: 'longest bullet',
        TOO_MANY: '{{count}} bullets - only the first {{max}} are sent',
        DISMISS: 'Dismiss'
			},
			CLICKUP: {
				MODAL_TITLE: 'Import from ClickUp',
				TASK_LABEL: 'ClickUp task URL or id',
				TASK_PLACEHOLDER: 'https://app.clickup.com/t/abc123 or abc123',
				TASK_REQUIRED: 'Enter a ClickUp task URL or id first',
				IMPORT: 'Import',
				PREVIEW_TITLE: 'Mapped listing content',
				COUNT_IMAGES: '{{count}} image(s)',
				COUNT_ATTRIBUTES: '{{count}} attribute(s)',
				NOT_PROVIDED: 'Not provided by the task',
				APPLY: 'Apply to listing',
				LINK_MODAL_TITLE: 'Link a ClickUp task',
				LINK_TASK: 'Link ClickUp task',
				LINK_ONLY: 'Link only',
				LINK_AND_IMPORT: 'Link & import content',
				LINKED: 'ClickUp task linked',
				LINK_FAILED: 'Could not link the ClickUp task',
				LAST_SYNCED: 'Last synced {{date}}',
				NEVER_SYNCED: 'Never synced',
				SYNC: 'Sync',
				SYNCED: 'Synced from ClickUp — updated: {{fields}}',
				SYNCED_NO_CHANGES: 'Already up to date',
				SYNC_FAILED: 'Could not sync from ClickUp',
				SYNC_CONFIRM_TITLE: 'Sync from ClickUp?',
				SYNC_CONFIRM_MESSAGE: 'Syncing overwrites title/description/bullets/brand/keywords/images from ClickUp. Continue?',
				UNLINK: 'Unlink',
				UNLINKED: 'ClickUp task unlinked',
				UNLINK_FAILED: 'Could not unlink the ClickUp task',
				UNLINK_CONFIRM_TITLE: 'Unlink ClickUp task?',
				UNLINK_CONFIRM_MESSAGE: 'This removes the link to the ClickUp task. Listing content stays unchanged.'
			},
			INTEGRATIONS: {
				AI_CARD_TITLE: 'AI providers',
				AI_CARD_DESC: 'Bring your own OpenAI / Anthropic API key to power listing content suggestions. Keys are stored encrypted and never displayed again after saving.',
				CLICKUP_CARD_TITLE: 'ClickUp',
				CLICKUP_CARD_DESC: 'Connect an org-level ClickUp API token to import listing content from tasks.',
				KEY_CONFIGURED: 'Key configured: {{maskedKey}}',
				TOKEN_CONFIGURED: 'Token configured: {{maskedToken}}',
				NOT_CONFIGURED: 'Not configured',
				LAST_VALIDATED: 'Last validated: {{date}}',
				NEVER_VALIDATED: 'Not validated yet',
				API_KEY: 'API key',
				API_KEY_PLACEHOLDER: 'Enter an API key...',
				API_KEY_REPLACE_PLACEHOLDER: 'Leave blank to keep the current key, or enter a new one to replace it...',
				API_TOKEN: 'API token',
				API_TOKEN_PLACEHOLDER: 'Enter an API token...',
				API_TOKEN_REPLACE_PLACEHOLDER: 'Enter a new token to replace the stored one...',
				DEFAULT_MODEL: 'Default model (optional)',
				MAKE_DEFAULT: 'Default provider',
				TEST: 'Test',
				SAVED: 'Integration settings saved',
				DELETED: 'Integration removed',
				TEST_SUCCESS: 'Connection test passed',
				TEST_FAILED: 'Connection test failed',
				KEY_REQUIRED: 'Enter an API key first',
				TOKEN_REQUIRED: 'Enter an API token first',
				DELETE_CONFIRM_TITLE: 'Remove integration?',
				DELETE_AI_CONFIRM: 'Remove the {{provider}} API key? AI suggestions through this provider will stop working.',
				DELETE_CLICKUP_CONFIRM: 'Remove the ClickUp token? ClickUp imports will stop working.'
			},
			PRODUCT_EDIT: {
				UOMS: 'Units of measure',
				UOMS_HINT: 'Applies to the dimension and weight values on the Main tab.',
				MANAGE_MARKETPLACES: 'Manage marketplaces & publish',
				SYNC_WARNING: 'Product saved, but listing content could not be synced. Try again from the Listing Content tab.'
			}
		},
		TRANSLATOR: {
			SELECT: 'あなたが使う言語を選んでください',
		},
		MENU: {
			NEW: '新しい',
			ACTIONS: '行動',
			CREATE_POST: '新しい投稿を作成',
			PAGES: 'Pages',
			FEATURES: '特徴',
			APPS: 'アプリ',
			DASHBOARD: 'ダッシュボード',
		},
		AUTH: {
			GENERAL: {
				OR: 'または',
				SUBMIT_BUTTON: '提出する',
				NO_ACCOUNT: 'アカウントを持っていない？',
				SIGNUP_BUTTON: 'サインアップ',
				FORGOT_BUTTON: 'パスワードをお忘れですか',
				BACK_BUTTON: 'バック',
				PRIVACY: 'プライバシー',
				LEGAL: '法的',
				CONTACT: '接触',
			},
			LOGIN: {
				TITLE: 'Create Account',
				BUTTON: 'Sign In',
			},
			FORGOT: {
				TITLE: 'Forgotten Password?',
				DESC: 'Enter your email to reset your password',
				SUCCESS: 'Your account has been successfully reset.'
			},
			REGISTER: {
				TITLE: 'Sign Up',
				DESC: 'Enter your details to create your account',
				SUCCESS: 'Your account has been successfuly registered.'
			},
			INPUT: {
				EMAIL: 'Email',
				FULLNAME: 'Fullname',
				PASSWORD: 'Password',
				CONFIRM_PASSWORD: 'Confirm Password',
				USERNAME: 'ユーザー名'
			},
			VALIDATION: {
				INVALID: '{{name}} is not valid',
				REQUIRED: '{{name}} is required',
				MIN_LENGTH: '{{name}} minimum length is {{min}}',
				AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
				NOT_FOUND: 'The requested {{name}} is not found',
				INVALID_LOGIN: 'The login detail is incorrect',
				REQUIRED_FIELD: 'Required field',
				MIN_LENGTH_FIELD: 'Minimum field length:',
				MAX_LENGTH_FIELD: 'Maximum field length:',
				INVALID_FIELD: 'Field is not valid',
			}
		},
		ECOMMERCE: {
			COMMON: {
				SELECTED_RECORDS_COUNT: 'Selected records count: ',
				ALL: 'All',
				SUSPENDED: 'Suspended',
				ACTIVE: 'Active',
				FILTER: 'Filter',
				BY_STATUS: 'by Status',
				BY_TYPE: 'by Type',
				BUSINESS: 'Business',
				INDIVIDUAL: 'Individual',
				SEARCH: 'Search',
				IN_ALL_FIELDS: 'in all fields'
			},
			ECOMMERCE: 'eCommerce',
			CUSTOMERS: {
				CUSTOMERS: 'Customers',
				CUSTOMERS_LIST: 'Customers list',
				NEW_CUSTOMER: 'New Customer',
				DELETE_CUSTOMER_SIMPLE: {
					TITLE: 'Customer Delete',
					DESCRIPTION: 'Are you sure to permanently delete this customer?',
					WAIT_DESCRIPTION: 'Customer is deleting...',
					MESSAGE: 'Customer has been deleted'
				},
				DELETE_CUSTOMER_MULTY: {
					TITLE: 'Customers Delete',
					DESCRIPTION: 'Are you sure to permanently delete selected customers?',
					WAIT_DESCRIPTION: 'Customers are deleting...',
					MESSAGE: 'Selected customers have been deleted'
				},
				UPDATE_STATUS: {
					TITLE: 'Status has been updated for selected customers',
					MESSAGE: 'Selected customers status have successfully been updated'
				},
				EDIT: {
					UPDATE_MESSAGE: 'Customer has been updated',
					ADD_MESSAGE: 'Customer has been created'
				}
			}
		}
	}
};
